import React from "react";
import Section7 from "./Section7/Section7";
import { Stack } from "@mui/material";
import Section10A from "./Section10/Section10A";
import FAQ from "./FAQs/FAQ";
import Benifits from "./Benifits/Benifits";
import Section9A from "./Section9/Section9A";
import ComponentData from "./data";

const SolutionComponent = ({ index }) => {
  return (
    <Stack>
      <Stack
        sx={{
          height: "auto",
          display: "flex",
          flexDirection: "column",
          // marginTop: "8px",
        }}
      >
        <Stack sx={{ height: "92vh" }}>
          {" "}
          <Stack sx={{ height: "100%", width: "100%" }}>
            <Section7 ComponentData={ComponentData} index={index} />
          </Stack>
        </Stack>{" "}
        <Stack sx={{ height: "100%", width: "100%" }}>
          <Section10A ComponentData={ComponentData} index={index} />
        </Stack>
        <Benifits ComponentData={ComponentData} index={index} />
        {/* <Section9A /> */}
        <FAQ />
      </Stack>
    </Stack>
  );
};

export default SolutionComponent;
